
// PAQUETES
import { useEffect, useState } from "react";
import {Routes, Route, Outlet, Navigate } from 'react-router-dom';
import axios from "axios";



export async function solicitarYGuardarUbicacion(usuarioEncontrado) {
    try {
        console.log("funcion ejecutada");
        if (!usuarioEncontrado?.idUsuario) return;
        if (!navigator.geolocation) return;

        navigator.geolocation.getCurrentPosition(
            async (position) => {
                try {
                    await axios.post("/actualizar-ubicacion-actual", {
                        params: {
                            idUsuario: usuarioEncontrado.idUsuario,
                            permiso: "aprobado",
                            latitud: position.coords.latitude,
                            longitud: position.coords.longitude,
                            precisionMetros: position.coords.accuracy || null,
                        }
                    });
                } 
                catch (errorUbicacion) { console.log("error guardando ubicación actual:", errorUbicacion); }
            },
            async () => {
                try {
                    await axios.post("/actualizar-ubicacion-actual", {
                        params: {
                            idUsuario: usuarioEncontrado.idUsuario,
                            permiso: "denegado",
                            latitud: null,
                            longitud: null,
                            precisionMetros: null,
                        }
                    });
                } 
                catch (errorUbicacion) { console.log("error guardando permiso de ubicación:", errorUbicacion); }
            },
            {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 300000,
            }
        );
    } 
    catch (errorUbicacion) { console.log("error solicitando ubicación:", errorUbicacion); }
}